import { useState } from 'react';
import { FaEdit } from "react-icons/fa";

import ComponentModal from '../../reusable/component-modal/component-modal.component';
import UpdateCategory from '../update-category/update-category.component';

import {
    MainContainer,
    CategoryContainerRow,
    CategoryDataContainer,
    CategoryDataText,
    CategoryDataTitle,
    CategoryOptionsContainer
} from './category-data.styles';

const CategoryData = ({ category, getCategory }) => {
    const [showUpdate, setShowUpdate] = useState(false);

    return (
        <MainContainer>
            <ComponentModal
                isOpen={showUpdate}
                onClose={() => setShowUpdate(false)}
                title="Update Category"
            >
                <UpdateCategory
                    category={category}
                    setShowEdit={setShowUpdate}
                    getCategory={getCategory}
                />
            </ComponentModal>

            <CategoryOptionsContainer>
                <FaEdit onClick={() => setShowUpdate(true)} />
            </CategoryOptionsContainer>

            <CategoryDataContainer>
                <CategoryContainerRow>
                    <CategoryDataTitle>Name:</CategoryDataTitle>
                    <CategoryDataText>{category.name}</CategoryDataText>
                </CategoryContainerRow>
                <CategoryContainerRow>
                    <CategoryDataTitle>Slug:</CategoryDataTitle>
                    <CategoryDataText>{category.slug}</CategoryDataText>
                </CategoryContainerRow>
                <CategoryContainerRow>
                    <CategoryDataTitle>Type:</CategoryDataTitle>
                    <CategoryDataText>{category.CategoryType ? category.CategoryType.name : 'No Associated Category Type'}</CategoryDataText>
                </CategoryContainerRow>
                <CategoryContainerRow>
                    <CategoryDataTitle>Description:</CategoryDataTitle>
                    <CategoryDataText>{category.description}</CategoryDataText>
                </CategoryContainerRow>
                <CategoryContainerRow>
                    <CategoryDataTitle>Status:</CategoryDataTitle>
                    <CategoryDataText>{category.status ? 'Active' : 'Inactive'}</CategoryDataText>
                </CategoryContainerRow>
            </CategoryDataContainer>
        </MainContainer>
    );
};

export default CategoryData;